
import { Component, Vue } from 'vue-property-decorator'
import { apiShopDetail, apiShopAdd, apiShopEdit, apiSetMealLists, apiPayConfigLists, apiUpdatePayConfigEnable, apiIncreasePayConfigEditCount, apiOauthConfigLists, apiUpdateOauthConfigEnable, apiIncreaseOauthConfigEditCount } from '@/api/shop'
import historyMeal from './components/history-meal.vue'
import { debounce } from '@/utils/util'
import lsPagination from '@/components/ls-pagination.vue'
import ExportData from '@/components/export-data/index.vue'
import LsDialog from '@/components/ls-dialog.vue'

@Component({
  components: {
    historyMeal
  }
})
export default class ListsDetail extends Vue {
  /** S Data **/

  identity: number | null = null; // 当前編輯用戶的身份ID

  setMealData: any = []

  payConfigOptions: any = [] // 支付配置选项

  oauthConfigOptions: any = [] // 三方登錄配置选项

  // 添加商城表单數據
  form: any = {
    name: '', // 名稱
    super_admin: '', // 賬號
    super_password: '', // 密碼
    super_password_confirm: '', // 確認密碼
    status: 1, // 商城狀態 0-停止服務 1-開启服務
    is_sync_goods: 0, // 是否可同步商品 0-不可同步 1-可以同步
    show_tweet_info: 1, // 顯示推文信息 0-不顯示 1-顯示
    contact: '', // 联系人
    contact_mobile: '', // 联系人手機號
    domain_alias: '', // 域名别名
    is_check_domain: 1, // 是否验证域名
    shop_url: '', // 当前域名
    set_meal_id: '', // 套餐ID
    expires_time: '', // 到期時間
    remark: '', // 備註
    shop_data: {}
  };

  // 表单校验
  rules = {
    name: [{ required: true, message: '請輸入商城名稱', trigger: 'blur' }],
    super_admin: [
      { required: true, message: '請輸入商城名稱', trigger: 'blur' }
    ],
    super_password: [
      { required: true, message: '請輸入密碼', trigger: 'blur' },
      {
        validator: (rule: object, value: string, callback: any) => {
          !value ? callback(new Error('請輸入密碼')) : callback()
        },
        trigger: 'blur'
      }
    ],
    super_password_confirm: [
      { required: true, message: '請再次输入密碼', trigger: 'blur' },
      {
        validator: (rule: object, value: string, callback: any) => {
          if (this.form.password) {
            if (!value) callback(new Error('請再次输入密碼'))
            if (value !== this.form.password) { callback(new Error('两次输入密碼不一致!')) }
          }
          callback()
        },
        trigger: 'blur'
      }
    ],
    set_meal_id: [{ required: true, message: '請選擇套餐', trigger: ['blur', 'change'] }],
    expires_time: [{ required: true, message: '請選擇到期時間', trigger: ['blur', 'change'] }]
  };

  /** E Data **/

  /** S Methods **/
  // 點擊表单提交
  onSubmit(formName: string) {
    // 验证表单格式是否正確
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return

      if (!this.identity) {
        this.handleShopAdd()
      } else {
        this.handleShopEdit()
      }
    })
  }

  // 添加商城
  async handleShopAdd(): Promise<void> {
    await apiShopAdd({ ...this.form })
    setTimeout(() => this.$router.go(-1), 500)
  }

  // 編輯商城
  async handleShopEdit(): Promise<void> {
    await apiShopEdit({ ...this.form, id: this.identity })
    setTimeout(() => this.$router.go(-1), 500)
  }

  // 獲取詳情
  async getShopDetailFunc(): Promise<void> {
    const res: any = await apiShopDetail({
      id: this.identity as number
    })
    Object.keys(res).map((key) => {
      this.$set(this.form, key, res[key])
    })
  }

  // 獲取套餐列表
  async getSetMealLists(): Promise<void> {
    const { lists } = await apiSetMealLists({ status: 1 })
    this.setMealData = lists
  }

  // 獲取支付配置列表
  async getPayConfigList(): Promise<void> {
    try {
      // 优先使用商城詳情中的sid，如果还沒有獲取到商城信息则传空
      const params = this.identity ? { sid: this.identity } : {}
      const data = await apiPayConfigLists(params)
      this.payConfigOptions = data

      // 只需要獲取支付配置列表，不需要設置pay_config_ids
    } catch (error) {
      console.error('獲取支付配置失敗:', error)
    }
  }

  // 處理支付配置复选框变化
  async handlePayConfigChange(payConfig: any, isChecked: boolean): Promise<void> {
    console.log(`支付配置 ${payConfig.name} (ID: ${payConfig.id}) 狀態变化: ${isChecked}`)

    // 先更新本地狀態，讓界面立即响应
    const index = this.payConfigOptions.findIndex((item: any) => item.id === payConfig.id)
    if (index !== -1) {
      this.payConfigOptions[index].is_enable = isChecked ? 1 : 0
    }

    try {
      // 调用API更新后端數據
      const response = await apiUpdatePayConfigEnable({
        pay_config_id: payConfig.id,
        is_enable: isChecked
      })

      console.log('API响应:', response)
      console.log(`支付配置 ${payConfig.name} (ID: ${payConfig.id}) 已成功更新為: ${isChecked}`)
    } catch (error) {
      console.error('更新支付配置啟用狀態失敗:', error)

      // 如果更新失敗，恢复本地狀態
      if (index !== -1) {
        this.payConfigOptions[index].is_enable = isChecked ? 0 : 1
      }

      // 顯示錯誤提示
      this.$message({
        message: `更新支付配置 "${payConfig.name}" 失敗`,
        type: 'error',
        duration: 3000
      })
    }
  }

  // 增加支付配置修改次数
  async handleIncreaseEditCount(payConfig: any): Promise<void> {
    try {
      const response = await apiIncreasePayConfigEditCount({
        pay_config_id: payConfig.id,
        increase_count: 1
      })

      // 更新本地顯示的修改次数
      const index = this.payConfigOptions.findIndex((item: any) => item.id === payConfig.id)
      if (index !== -1) {
        this.payConfigOptions[index].edit_count = response.edit_count
      }

      this.$message({
        message: `已為 "${payConfig.name}" 增加修改次数，当前剩餘: ${response.edit_count}`,
        type: 'success',
        duration: 2000
      })
    } catch (error) {
      console.error('增加修改次数失敗:', error)
      this.$message({
        message: `增加修改次数失敗`,
        type: 'error',
        duration: 3000
      })
    }
  }

  // 增加支付配置修改次数（复选框按钮點擊）
  async handleIncreasePayConfigEditCount(payConfig: any): Promise<void> {
    await this.handleIncreaseEditCount(payConfig)
  }

  // 獲取三方登錄配置列表
  async getOauthConfigList(): Promise<void> {
    try {
      // 优先使用商城詳情中的sid，如果还沒有獲取到商城信息则传空
      const params = this.identity ? { sid: this.identity } : {}
      const data = await apiOauthConfigLists(params)
      this.oauthConfigOptions = data
    } catch (error) {
      console.error('獲取三方登錄配置失敗:', error)
    }
  }

  // 處理三方登錄配置复选框变化
  async handleOauthConfigChange(oauthConfig: any, isChecked: boolean): Promise<void> {
    console.log(`三方登錄配置 ${oauthConfig.name} (ID: ${oauthConfig.id}) 狀態变化: ${isChecked}`)

    // 先更新本地狀態，讓界面立即响应
    const index = this.oauthConfigOptions.findIndex((item: any) => item.id === oauthConfig.id)
    if (index !== -1) {
      this.oauthConfigOptions[index].is_enable = isChecked ? 1 : 0
    }

    try {
      // 调用API更新后端數據
      const response = await apiUpdateOauthConfigEnable({
        oauth_config_id: oauthConfig.id,
        is_enable: isChecked
      })

      console.log('API响应:', response)
      console.log(`三方登錄配置 ${oauthConfig.name} (ID: ${oauthConfig.id}) 已成功更新為: ${isChecked}`)
    } catch (error) {
      console.error('更新三方登錄配置啟用狀態失敗:', error)

      // 如果更新失敗，恢复本地狀態
      if (index !== -1) {
        this.oauthConfigOptions[index].is_enable = isChecked ? 0 : 1
      }

      // 顯示錯誤提示
      this.$message({
        message: `更新三方登錄配置 "${oauthConfig.name}" 失敗`,
        type: 'error',
        duration: 3000
      })
    }
  }

  // 增加三方登錄配置修改次数
  async handleIncreaseOauthConfigEditCount(oauthConfig: any): Promise<void> {
    try {
      const response = await apiIncreaseOauthConfigEditCount({
        oauth_config_id: oauthConfig.id,
        increase_count: 1
      })

      // 更新本地顯示的修改次数
      const index = this.oauthConfigOptions.findIndex((item: any) => item.id === oauthConfig.id)
      if (index !== -1) {
        this.oauthConfigOptions[index].edit_count = response.edit_count
      }

      this.$message({
        message: `已為 "${oauthConfig.name}" 增加修改次数，当前剩餘: ${response.edit_count}`,
        type: 'success',
        duration: 2000
      })
    } catch (error) {
      console.error('增加三方登錄配置修改次数失敗:', error)
      this.$message({
        message: `增加修改次数失敗`,
        type: 'error',
        duration: 3000
      })
    }
  }

    /** E Methods **/

  /** S Life Cycle **/
  created() {
    const query: any = this.$route.query

    // 編輯模式：初始化數據
    this.identity = +query.id
    if (+query.id) {
      this.getShopDetailFunc().then(() => {
        // 獲取完商城詳情后再獲取支付配置和三方登錄配置
        this.getPayConfigList()
        this.getOauthConfigList()
      })
    }

    this.onSubmit = debounce(this.onSubmit, 2000)
    this.getSetMealLists()

    // 如果是新增模式，直接獲取支付配置和三方登錄配置
    if (!+query.id) {
      this.getPayConfigList()
      this.getOauthConfigList()
    }
  }
  /** E Life Cycle **/
}
